import React, { FC } from "react";
import { List } from "antd";
import {
  CalendarOutlined,
  MailOutlined,
  SelectOutlined,
} from "@ant-design/icons";
import { useIntl } from "react-intl";

export const AppointmentsInfo: FC = () => {
  const { formatMessage } = useIntl();

  const items: { title: string; subTitle: string; icon: React.ReactNode }[] = [
    {
      title: formatMessage({ id: "home.info.2.option-1.title" }),
      subTitle: formatMessage({ id: "home.info.2.option-1.sub-title" }),
      icon: <SelectOutlined />,
    },
    {
      title: formatMessage({ id: "home.info.2.option-2.title" }),
      subTitle: formatMessage({ id: "home.info.2.option-2.sub-title" }),
      icon: <CalendarOutlined />,
    },
    {
      title: formatMessage({ id: "home.info.2.option-3.title" }),
      subTitle: formatMessage({ id: "home.info.2.option-3.sub-title" }),
      icon: <MailOutlined />,
    },
  ];

  return (
    <div>
      <List
        style={{ color: "white" }}
        dataSource={items}
        renderItem={(item) => (
          <List.Item>
            <List.Item.Meta
              avatar={<span style={{ color: "white" }}>{item.icon}</span>}
              title={<span style={{ color: "white" }}>{item.title}</span>}
              description={
                <span style={{ color: "lightgray" }}>{item.subTitle}</span>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
};
